<template>
  <div>
    <a-spin :spinning="isLoading">
      <a-form layout="inline">
        <a-form-item label="Número de Instancia">
          <a-input v-model.number="searchForm.instanceId" class="margenEstilosDashboard" placeholder="Número de Instancia"/>
        </a-form-item>
        <br>
        <a-form-item label="Tipo de Documento">
          <a-select v-model="searchForm.documentType" class="margenEstilosDashboard" placeholder="Tipo de Documento">
            <a-select-option value="null">-- Seleccione --</a-select-option>
            <a-select-option value="DNI">DNI</a-select-option>
            <a-select-option value="CE">CE</a-select-option>
            <a-select-option value="RUC">RUC</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Número de Documento">
          <a-input v-model="searchForm.documentNumber" class="margenEstilosDashboard" placeholder="Número de Documento"/>
        </a-form-item>
        <br>
        <a-form-item label="Vista">
          <a-select v-model="searchForm.view" class="margenEstilosDashboard view-custom" placeholder="Vista">
            <a-select-option value="null">-- Seleccione --</a-select-option>
            <a-select-option value="PERSONAL_DATA">DATOS DEL SOLICITANTE</a-select-option>
            <a-select-option value="BUSINESS_DATA">DATOS DEL NEGOCIO</a-select-option>
            <a-select-option value="ACTIVITY_DATA">INFORMACIÓN ACTIVIDAD</a-select-option>
            <a-select-option value="FINANCIAL_DATA">ESTADOS FINANCIEROS</a-select-option>
            <a-select-option value="DOCUMENTS">DOCUMENTOS</a-select-option>
            <a-select-option value="END">TERMINADA</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Estado">
          <a-select v-model="searchForm.state" class="margenEstilosDashboard state-custom" placeholder="Estado">
            <a-select-option value="null">-- Seleccione --</a-select-option>
            <a-select-option value="START">INICIADA</a-select-option>
            <a-select-option value="IN_PROGRESS">EN PROGRESO</a-select-option>
            <a-select-option value="IN_REVIEW">EN REVISIÓN</a-select-option>
            <a-select-option value="APPROVE_ANALISTA">APROBADO ANALISTA</a-select-option>
            <a-select-option value="REJECT_ANALISTA">RECHAZADO ANALISTA</a-select-option>
            <!-- <a-select-option value="END">FINALIZADA</a-select-option> -->
          </a-select>
        </a-form-item>
        <br>
        <a-form-item>
          <date-range-picker
            ref="picker"
            opens="right"
            :locale-data="{ format: 'yyyy-mm-dd' }"
            :singleDatePicker="false"
            v-model="searchForm.dateRange"
          />
        </a-form-item>
        <br>
        <a-form-item>
          <a-button class="margenEstilosDashboard" @click="onSearch">Consultar</a-button>
          <a-button class="margenEstilosDashboard" @click="onDownload">Exportar</a-button>
        </a-form-item>
      </a-form>
      <vue-good-table
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        :pagination-options="{
          enabled: true,
          perPageDropdown: [25, 50, 75],
          dropdownAllowAll: false,
        }"
        :rows="rows"
        :columns="columns"
        styleClass="tableOne vgt-table"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'button'">
            <a href="javascript:void(0)" @click="onReview(props.row.id)">
              <i class="i-Pen-5 text-25 text-success mr-2"></i>
            </a>
          </span>
        </template>
      </vue-good-table>
    </a-spin>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import _ from 'lodash'
import qs from 'qs'
import axios from 'axios'
import { match } from 'x-match-expression'

import modulesType from '@/store/types/modules'

const service = axios.create({
  baseURL: process.env.VUE_APP_MAF_EMPRENDEDOR_BASE_API_URL,
  headers: {
    'author-id': process.env.VUE_APP_MAF_EMPRENDEDOR_HEADERS_AUTHOR_ID,
    'author-username': process.env.VUE_APP_MAF_EMPRENDEDOR_HEADERS_AUTHOR_USERNAME,
    'author-role': process.env.VUE_APP_MAF_EMPRENDEDOR_HEADERS_AUTHOR_ROLE,
    Authorization: `Basic ${Buffer.from(`${process.env.VUE_APP_MAF_EMPRENDEDOR_BASIC_AUTH_USERNAME}:${process.env.VUE_APP_MAF_EMPRENDEDOR_BASIC_AUTH_PASSWORD}`).toString('base64')}`,
  },
})

export default {
  dependencies: ['DynamicCallService', 'GenericService'],
  name: 'Module',
  components: {
    DateRangePicker,
  },
  data() {
    return {
      isLoading: false,
      columns: [
        { label: 'CÓDIGO', field: 'shortId', sortable: false },
        { label: 'N° Instancia', field: 'instanceId', sortable: false },
        { label: 'Tipo Documento', field: 'client.documentType', sortable: false },
        { label: 'N° Documento', field: 'client.documentNumber', sortable: false },
        { label: 'Nombre', field: 'fullName', sortable: false },
        { label: 'Fecha Registro', field: 'createdAt', sortable: false },
        { label: 'Usuario Responsable', field: 'user', sortable: false },
        { label: 'Estado', field: 'state', sortable: false },
        { label: 'Vista', field: 'view', sortable: false },
        { label: 'Giro económico', field: 'sector', sortable: false },
        { label: 'Tipo de negocio', field: 'type', sortable: false },
        { label: 'Teléfono', field: 'client.phoneNumber', sortable: false },
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        filters: {},
        page: 1,
        limit: 25,
      },
      searchForm: {
        documentType: 'null',
        instanceId: '',
        documentNumber: '',
        state: 'null',
        view: 'null',
        dateRange: {
          startDate: DateTime.now().toJSDate(),
          endDate: DateTime.now().toJSDate(),
        },
        vehicleStatus: 'null',
      },
      views: [
        { value: null, text: '-- Seleccione --' },
        { value: 'PersonalData', text: 'Datos Personales' },
        { value: 'EmploymentData', text: 'Datos Laborales' },
        { value: 'FinancingData', text: 'Datos del Financiamiento' },
        { value: 'Dictum', text: 'Dictamen' },
        { value: 'Pin', text: 'Pin' },
        { value: 'Documents', text: 'Documentos' },
        { value: 'End', text: 'Fin' },
      ],
      states: [
        { value: null, text: '-- Seleccione --' },
        { value: 'ACTIVE', text: 'Progreso' },
        { value: 'DONE', text: 'Solicitado' },
        { value: 'APPROVED', text: 'Aprobado' },
        { value: 'DERIVED', text: 'Derivado' },
      ],
      documentType: [
        { value: null, text: '-- Seleccione --' },
        { value: 'DNI', text: 'DNI' },
        { value: 'CE', text: 'CE' },
      ],
      token: null,
    }
  },
  async created() {
    await this.setModule()
    // await this.getToken()
    await this.onSearch()
  },
  watch: {
    $route: 'setModule',
  },
  methods: {
    async setModule() {
      await this.$store.dispatch(modulesType.actions.setModule, {
        key: this.$route.params.key,
      })
    },
    // async getToken() {
    //   try {
    //     this.isLoading = true

    //     const token = await this.GenericService.get('maf-emprendedor/token')

    //     this.token = token
    //   } catch (err) {
    //     this.$notification.warning({
    //       message: 'ERROR',
    //       description: _.get(err, 'response.data.message', err.message),
    //     })
    //   } finally {
    //     this.isLoading = false
    //   }
    // },
    onSearch() {
      this.serverParams.filters = {}

      if (typeof this.searchForm.instanceId === 'number') {
        this.serverParams.filters = {
          ...this.serverParams.filters,
          instanceId: this.searchForm.instanceId,
        }
      }

      if (this.searchForm.documentNumber.length > 0) {
        if (this.searchForm.documentType === 'null') {
          this.$notification.warning({
            message: 'ERROR',
            description: _.get('Debe seleccionar tipo de documento', 'response.data.message', 'Debe seleccionar tipo de documento'),
          })
          return
        }
        this.serverParams.filters = {
          ...this.serverParams.filters,
          documentNumber: this.searchForm.documentNumber,
        }
      }

      if (this.searchForm.state && this.searchForm.state !== 'null') {
        this.serverParams.filters = {
          ...this.serverParams.filters,
          state: this.searchForm.state,
        }
      }

      if (this.searchForm.view && this.searchForm.view !== 'null') {
        this.serverParams.filters = {
          ...this.serverParams.filters,
          view: this.searchForm.view,
        }
      }

      if (this.searchForm.documentType && this.searchForm.documentType !== 'null') {
        this.serverParams.filters = {
          ...this.serverParams.filters,
          documentType: this.searchForm.documentType,
        }
      }

      if (this.searchForm.dateRange.startDate) {
        // this.serverParams.filters.push({
        //   field: 'createdAt',
        //   operator: 'gte',
        //   value: DateTime.fromJSDate(this.searchForm.dateRange.startDate).startOf('day').toISO(),
        // })
        this.serverParams.filters = {
          ...this.serverParams.filters,
          startDate: DateTime.fromJSDate(this.searchForm.dateRange.startDate).toFormat('yyyy-MM-dd'),
        }
      }

      if (this.searchForm.dateRange.endDate) {
        this.serverParams.filters = {
          ...this.serverParams.filters,
          endDate: DateTime.fromJSDate(this.searchForm.dateRange.endDate).toFormat('yyyy-MM-dd'),
        }
      }

      this.loadItems()
    },
    onDownload() {
      const query = _.cloneDeep(this.serverParams)

      query.t = this.token

      // const url = `${process.env.VUE_APP_MAF_HUNTER_BASE_API_URL}/reports/download?&startDate${this.serverParams.filters.startDate}&endDate=${this.serverParams.filters.endDate}&documentNumber=${this.serverParams.filters.documentNumber}`
      // documentType: 'null',
      //   instanceId: '',
      //   documentNumber: '',
      //   state: 'null',
      //   view: 'null',
      //   dateRange: {
      //     startDate: DateTime.now().toJSDate(),
      //     endDate: DateTime.now().toJSDate(),
      //   },
      const queryParams = `${qs.stringify(this.serverParams.filters)}`

      const url = `${process.env.VUE_APP_MAF_EMPRENDEDOR_BASE_API_URL}/reports/robot/download?${queryParams}`
      console.log({ url })

      window.open(url, '_blank')
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ limit: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      // const [{ field: by, type }] = params
      // this.updateParams({
      //   orders: type === 'none' ? [] : [{
      //     type,
      //     by,
      //   }],
      // })
      this.loadItems()
    },
    onColumnFilter(params) {
      // this.updateParams(params)
      this.loadItems()
    },
    async loadItems() {
      try {
        this.isLoading = true

        const { data: { items, total } } = await service.get(`/applications?${qs.stringify({
          filters: { ...this.serverParams.filters },
          role: 'ROBOT',
        })}`)
        this.totalRecords = total

        this.rows = items.map((row) => ({
          ...row,
          shortId: 'E' + row.shortId.toString().padStart(8, 0),
          createdAt: DateTime.fromISO(row.createdAt).setZone('America/Lima').toFormat('dd-MM-yyyy'),
          view: match(row.view)
            .caseEqual('PERSONAL_DATA', () => 'DATOS DEL SOLICITANTE')
            .caseEqual('BUSINESS_DATA', () => 'DATOS DEL NEGOCIO')
            .caseEqual('ACTIVITY_DATA', () => 'INFORMACIÓN ACTIVIDAD')
            .caseEqual('FINANCIAL_DATA', () => 'ESTADOS FINANCIEROS')
            .caseEqual('DOCUMENTS', () => 'DOCUMENTOS')
            .caseEqual('END', () => 'TERMINADA')
            .default(''),
          fullName: match(row.client.documentType)
            .caseEqual('RUC', () => row.client.tradeName)
            .caseEqual('DNI', () => `${row.client.firstName ?? ''} ${row.client.lastName ?? ''} ${row.client.paternalLastName ?? ''} ${row.client.maternalLastName ?? ''}`)
            .caseEqual('CE', () => `${row.client.firstName ?? ''}`)
            .default(''),
          state: match(row.state)
            .caseEqual('START', () => 'INICIADA')
            .caseEqual('IN_PROGRESS', () => 'EN PROGRESO')
            .caseEqual('IN_REVIEW', () => 'EN REVISIÓN')
            .caseEqual('APPROVE_ANALISTA', () => 'APROBADO ANALISTA')
            .caseEqual('REJECT_ANALISTA', () => 'RECHAZADO ANALISTA')
            .default(''),
          user: row.createdBy?.username.toUpperCase(),
          sector: row.sector ?? '',
          type: `${row.type ?? ''} ${row.otherType ?? ''}`,
        }))
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: _.get(err, 'response.data.message', err.message),
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style>
.view-custom {
  min-width: 186px !important;
}
.state-custom {
  min-width: 168px !important;
}
</style>
